import React from 'react';
import cn from 'clsx';

import Tooltip from '../../library/tooltip/tooltip';
import Typography from '../../library/typography/typography';
import TireAttributeIcon from './components/tire-attribute-icon/tire-attribute-icon';

import { TIRE_ATTRIBUTE_ICON_DESCRIPTION } from '../../shared/constants/products';

import styles from './tire-attribute-icons.scss';

interface TireAttributeIconsProps {
  className?: string;
  hideTitle?: boolean;
  icons?: string[];
}

function TireAttributeIcons(props: TireAttributeIconsProps) {
  const { className, hideTitle = false, icons } = props;

  if (!(Array.isArray(icons) && icons.length > 0)) {
    return null;
  }

  return (
    <span
      className={cn(styles['container'], `tire-attribute-icons ${className}`)}
    >
      {!hideTitle && (
        <Typography tag="span" weight="black">
          Features
        </Typography>
      )}

      {icons.map((icon, i) => {
        if (!TIRE_ATTRIBUTE_ICON_DESCRIPTION[icon]) return null;
        return (
          <Tooltip
            className={styles['tooltip']}
            content={TIRE_ATTRIBUTE_ICON_DESCRIPTION[icon].description}
            hoverOver
            key={`tire-icon-tooltip-${i}`}
            render={
              <div className={styles['icon-container']}>
                <TireAttributeIcon name={icon} />
              </div>
            }
          />
        );
      })}
    </span>
  );
}

export default TireAttributeIcons;
